import React from 'react';
import PropTypes from 'prop-types';
import { useThemeTokens } from '@telus-uds/components-base';
import styled from 'styled-components';
import { getAriaLabel, getTimestamp } from '../helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContainer = /*#__PURE__*/styled.button.withConfig({
  displayName: "SplashButton__ButtonContainer",
  componentId: "components-web__sc-1oe22fk-0"
})({
  background: 'none',
  border: 0,
  padding: 0,
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer'
});
const ButtonContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "SplashButton__ButtonContent",
  componentId: "components-web__sc-1oe22fk-1"
})({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 64,
  height: 64,
  background: _ref => {
    let {
      buttonContentBackground
    } = _ref;
    return buttonContentBackground ?? 'none';
  },
  borderRadius: '100%',
  transition: 'background 0.2s ease-in-out',
  [`${ButtonContainer}:hover &`]: {
    background: _ref2 => {
      let {
        buttonContentChildrenBackground
      } = _ref2;
      return buttonContentChildrenBackground;
    }
  }
});
const SplashButton = _ref3 => {
  let {
    copy,
    tokens,
    variant,
    videoLength
  } = _ref3;
  const {
    buttonContentChildrenBackground
  } = useThemeTokens('SplashButton', tokens, variant, {
    hover: true
  });
  const {
    playIcon: PlayIcon,
    playIconColor,
    ...themeTokens
  } = useThemeTokens('SplashButton', tokens, variant);
  const ariaLabel = getAriaLabel(getTimestamp(videoLength), copy);
  return /*#__PURE__*/_jsx(ButtonContainer, {
    "aria-label": ariaLabel,
    children: /*#__PURE__*/_jsx(ButtonContent, {
      ...themeTokens,
      buttonContentChildrenBackground: buttonContentChildrenBackground,
      children: /*#__PURE__*/_jsx(PlayIcon, {
        size: 27,
        color: playIconColor
      })
    })
  });
};
SplashButton.propTypes = {
  videoLength: PropTypes.number,
  tokens: PropTypes.object,
  variant: PropTypes.object,
  copy: PropTypes.oneOf(['en', 'fr'])
};
export default SplashButton;